import React, { useState } from 'react';
import { servicesData } from '../data/servicesData';
import '../styles/ContactForm.css';

const ContactForm = ({ initialService = 'Contact Us', onSubmitSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: initialService,
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://sheetdb.io/api/v1/yeglfi70ssbxg', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: [{
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            service: formData.service,
            msg: formData.message
          }]
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: initialService,
          message: ''
        });
        if (onSubmitSuccess) onSubmitSuccess();
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitStatus === 'success') {
    return (
      <div className="form-success">
        <h3>Thank You!</h3>
        <p>Your message has been sent successfully. We'll get back to you soon!</p>
        <button 
          onClick={() => setSubmitStatus(null)}
          className="cta-button"
        >
          Send Another Message
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="form-input"
          placeholder="Your Name"
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="form-input"
          placeholder="Your Email"
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Phone <span className="required">*</span></label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="form-input"
          placeholder="Your Phone Number"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="service">Service</label>
        <select
          id="service"
          name="service"
          value={formData.service}
          onChange={handleChange}
          className="form-input"
        >
          <option value="Contact Us">General Inquiry</option>
          {servicesData.map(service => (
            <option key={service.id} value={service.title}>
              {service.title}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="form-textarea"
          rows="5"
          placeholder="How can we help you?"
        ></textarea>
      </div>

      {submitStatus === 'error' && (
        <div className="form-error">
          There was an error submitting the form. Please try again.
        </div>
      )}

      <button 
        type="submit" 
        className="cta-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
};

export default ContactForm;
